import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { useDrag, useDrop } from 'react-dnd'
import styled from 'styled-components'
import colors from '../../../configuration/colors'
import { ItemTypes } from '../../mycourses/Journey/ItemTypes'
import _SortOrderIcon from '../../../static/images/mycourses/SortOrder.svg'
import P1 from '../../typography/paragraphs/P1'

const LevelFlexContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  border-radius: 5px;
  background-color: ${colors.white};
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.12);
  margin-bottom: 12px;
  padding: 10px 17px;
  align-items: center;
`

const SortIcon = styled.img.attrs({
  src: _SortOrderIcon
})`
  width: 19px;
  height: 9px;
  margin-right: 18px;
`

export const DraggableLevelItem = ({ level, id, index, moveCard }) => {
  const ref = useRef(null)
  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.LEVEL_ROW,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId()
      }
    },
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex)
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex
    }
  })
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.LEVEL_ROW,
    item: () => {
      return { id, index }
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  })

  const opacity = isDragging ? 0 : 1
  drag(drop(ref))

  return (
    <div ref={ref}>
      <LevelFlexContainer
      // onMouseEnter={() => setShow(true)}
      // onMouseLeave={() => setShow(false)}
      >
        <SortIcon />
        <P1>{level.name}</P1>
      </LevelFlexContainer>
    </div>
  )
}

DraggableLevelItem.propTypes = {
  level: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired
}

export default DraggableLevelItem



// WEBPACK FOOTER //
// ./src/components/modal/SortLevelOrder/DraggableLevelItem.js